@if (imageUrl() && !imageLoadError(); as imgUrl) {
  <img
    [src]="imageUrl()"
    [class.avatar__image]="!bigImage() && !isSmall()"
    [class.avatar-small__image]="isSmall() && !bigImage()"
    [class.avatar__image--big]="bigImage()"
    [class.avatar__image--circle]="shape() === 'circle' && !isSmall()"
    [class.avatar-small__image--circle]="
      shape() === 'circle' && isSmall() && !bigImage()
    "
    (error)="onImageError()"
    alt="Avatar" />
} @else {
  <div fxLayout [class.avatar]="!isSmall()" [class.avatar-small]="isSmall()">
    @if (avatarLetters()) {
      <span
        [class.avatar__letter]="!isSmall()"
        [class.avatar-small__letter]="isSmall()"
        [class.avatar__image]="!bigImage()"
        [class.avatar__image--big]="bigImage()"
        [class.avatar__image--circle]="shape() === 'circle' && !isSmall()"
        [class.avatar__letter--circle]="shape() === 'circle' && !isSmall()"
        [class.avatar-small__letter--circle]="shape() === 'circle' && isSmall()"
        [style.background-color]="backgroundColor() || null">
        {{ avatarLetters() }}
      </span>
    }
    @if (!isStatusActive()) {
      <span class="avatar__status pending"></span>
    }
  </div>
}
